<template>
    <div v-if="podeVer">
      <page-nav-bar ref="navBar" v-if="propsRota.nav" :isMenuVisible="propsRota.menuVisible" :isFullPage="propsRota.page" :podeMinimizarMenu="propsRota.podeMinimizarMenu"></page-nav-bar>
      <page-container :page="propsRota.page" :css="propsRota.css" class="">
        <Suspense :key="random">
          <router-view></router-view>
          <template #fallback>
            <vis-loading id="loadingVisPageBase" :visivel="true"></vis-loading>
          </template>
        </Suspense>
      </page-container>
    </div>
</template>

<script>

import PageNavBar from '@/components/containers/Navbar/PageNavbar'
import PageContainer from '@/components/containers/PageContainer/PageContainer'
import { mapGetters } from 'vuex'

const propsPadrao = {
          nav: false,
          navMobile: false,
          page: false,
          css: '',
          minWidth:0,
          menuVisible: true,
          podeMinimizarMenu: false,
          itensMenu: [],
      }

export default {
    components: {
        PageNavBar, PageContainer
    },
    data() {
        return {
            versaoClient: VERSAO_APP,
            propsRota: {
                nav: false,
                navMobile: false,
                page: false,
                css: '',
                minWidth:0,
                menuVisible: false,
                podeMinimizarMenu: false,
                itensMenu: [],
            },
            random: 0
        }
    },
    computed: {
        ...mapGetters(["usuario"]),
        podeVer() {
          return this.usuario?.id
        }
    },
    watch: {
        '$router.currentRoute.value': {
          immediate: true,
          handler(newVal) {
            this.random = Math.random() //Usado para ter loading em qualquer rota por conta do Suspensible
            // console.log('Entrou no Watch do CurrentRoute', newVal)
            Object.keys(this.propsRota).forEach(k => {
                if(newVal.meta.hasOwnProperty(k)) {
                    this.propsRota[k] = newVal.meta[k]
                } else {
                    this.propsRota[k] = propsPadrao[k]
                }
            })
          }
        }
    },
    mounted() {
        this.getAppStyleMinWidth()     
    },
    methods: {
        getAppStyleMinWidth() {
            let app = document.querySelector('#app');
            if (this.minWidth)
                app.style.minWidth = `${this.minWidth}px`
            else
                app.style.minWidth = null;
        }
    }
}
</script>


<style lang="scss">
#menu-esquerdo-mobile {
    .logo-menu {
        margin-bottom: 10px;
        height: 50px;
        width: 140px;
        display: flex;
        cursor: pointer;
        img {
            object-fit: contain;
            max-height: 50px;
            max-width: 140px;
            height: auto;
            width: auto;
            overflow: hidden;
            margin: auto;
            cursor: pointer;
        }
    } 

    .info-versao {
        position: absolute;
        bottom: 2px;
        //right: 4px;
        font-size: 10px;
    }  
    
    .item-menu {
        height: 40px;
        display: flex;
        align-items: center;
        padding-left: 8px;
    }

    .icone-menu {
        padding-left: 8px;
    }

    .nome-menu {
        vertical-align: middle;
        padding-left: 10px;
    }
}

.tudo-mobile {
    display: flex;
    flex-direction: column;
    height: 100%;

    #menu-mobile {
        padding-left: 5px;
        padding-right: 5px;

        .dx-toolbar-items-container {
          height: 40px !important;
        }

    } 
}

.mobile {
    padding: 0 3px;
    
    .main-content {
        .pagina.content {
            height: calc(100% - 6px);
        }
    }    
}

.pagina {
  overflow: hidden !important;
}
.conteudo-pagina {
    margin-left: auto;
    margin-right: auto;
    width: 100%;
}

.dx-checkbox.dx-checkbox-has-text.dx-widget {
    margin-top: 8px;
}

.dx-texteditor.dx-editor-filled .dx-texteditor-input, .dx-texteditor.dx-editor-outlined .dx-texteditor-input {
  padding: 8px 8px 8px
}

.form-big-group {
  padding-top: 20px;
}

label {
  margin-bottom: 0.1rem;
}

.titulo-grupo {
  padding-left: 5px;

  .titulo {
    display: inline;
    padding-left: 5px;
  }
}

.tab-panel-tab {
  padding: 20px;
}

.linha-grupo {
  margin-top: 5px;
  margin-bottom: 10px;
  width: 100%;
}

.row.linha-interna {
  padding: 0;
}

.altura-do-pai {
  height: inherit !important;
}

.largura-do-pai {
  width: 100% !important;
  max-width: 100% !important;
}

.largura-limitada-1400 {
  max-width: 1400px;
}

.borda-limite-1400, .borda-limite-800 {
  border: solid 1px;
}

@media screen and (max-width: 1430px) {
  .borda-limite-1400 {
    border: none !important;
  }
}

.largura-limitada-1200 {
  max-width: 1200px;
}

.largura-limitada-1000 {
  max-width: 1000px;
}

.largura-limitada-800 {
  max-width: 800px;
}

@media screen and (max-width: 830px) {
  .borda-limite-800 {
    border: none !important;
  }
}

.largura-limitada-600 {
  max-width: 600px;
}

.largura-limitada-400 {
  max-width: 400px;
}

.no-margin {
    margin: 0 !important;
}

.no-padding {
    padding: 0 !important;
}

.ps > .ps__scrollbar-y-rail {
  background-color: unset !important;
}

.dx-command-select {
  padding-left: unset !important;
}

//[class^='dx-swatch'] .dx-menu-item,
//[class^='dx-swatch'] .dx-field-label-text,
//[class^='dx-swatch'] .dx-datagrid-nodata, 
//[class^='dx-swatch'] div:not([class]),
//[class^='dx-swatch'] b:not([class])
//{
//  color: #cecece;
//}
//[class^='dx-swatch'] .ctx-menu-item  {
//  color: #DDD
//}
//
//[class^='dx-swatch'] .dx-placeholder {
//  color: rgba(148, 148, 148, 0.87);
//}
//
//[class^='dx-swatch'] .dx-popup-normal {
//  background-color: #404040;
//}
//
//[class^='dx-swatch'] h1, h1 {
//  font-size: 2.5rem !important;
//}
//[class^='dx-swatch'] h2, h2 {
//  font-size: 2.0rem !important;
//}
//[class^='dx-swatch'] h3, h2 {
//  font-size: 1.75rem !important;
//}
//[class^='dx-swatch'] h4, h3 {
//  font-size: 1.5rem !important;
//}
//[class^='dx-swatch'] h5, h4 {
//  font-size: 1.25rem !important;
//}
//[class^='dx-swatch'] .dx-highlight-outline.dx-pointer-events-target {
//  padding: 0 !important;
//}
.dx-datagrid-filter-row .dx-editor-cell .dx-editor-with-menu .dx-texteditor-input, .dx-datagrid-filter-row .dx-editor-cell .dx-editor-with-menu .dx-placeholder:before {
  padding-left: 32px;
}
</style>

<style> 
/* previne diferenças no espaçamento de linhas do dbtexto */
p {
  margin: 0 !important;
}

#visDBText .ql-position-absolute p, #visDBText .ql-position-absolute span,
.ql-editor .ql-position-absolute p, .ql-editor .ql-position-absolute span,
#visDBText p.ql-position-absolute, #visDBText span.ql-position-absolute,
.ql-editor p.ql-position-absolute, .ql-editor span.ql-position-absolute
{
  width: fit-content !important;
  white-space: -moz-pre-space !important;
} 
@supports (-ms-ime-align:auto) {
  #visDBText p, #visDBText span,
  .ql-editor p, .ql-editor span {
    word-break: normal !important;
  }
}
/* #loadingVisPageBase {
  z-index: 0 !important;
} */

/* css aqui são usando pelos atributos customizados do editor html (quill) */

/* lineheight */
[class*='ql-lineheight-1.0'] {
  line-height: 1.0 !important;
}
[class*='ql-lineheight-1.2'] {
  line-height: 1.2 !important;
}
[class*='ql-lineheight-1.5'] {
  line-height: 1.5 !important;
}
[class*='ql-lineheight-1.6'] {
  line-height: 1.6 !important;
}
[class*='ql-lineheight-1.8'] {
  line-height: 1.8 !important;
}
[class*='ql-lineheight-2.0'] {
  line-height: 2.0 !important;
}
[class*='ql-lineheight-2.4'] {
  line-height: 2.4 !important;
}
[class*='ql-lineheight-2.0'] {
  line-height: 2.8 !important;
}
[class*='ql-lineheight-3.0'] {
  line-height: 3.0 !important;
}
[class*='ql-lineheight-4.0'] {
  line-height: 4.0 !important;
}
[class*='ql-lineheight-5.0'] {
  line-height: 5.0 !important;
}

/* top */
[class*='ql-top-unset'] { top: unset !important; }
[class*='ql-top-0%'] { top: 0% !important; }
[class*='ql-top-2%'] { top: 2% !important; }
[class*='ql-top-4%'] { top: 4% !important; }
[class*='ql-top-6%'] { top: 6% !important; }
[class*='ql-top-8%'] { top: 8% !important; }
[class*='ql-top-10%'] { top: 10% !important; }
[class*='ql-top-12%'] { top: 12% !important; }
[class*='ql-top-14%'] { top: 14% !important; }
[class*='ql-top-16%'] { top: 16% !important; }
[class*='ql-top-18%'] { top: 18% !important; }
[class*='ql-top-20%'] { top: 20% !important; }
[class*='ql-top-22%'] { top: 22% !important; }
[class*='ql-top-24%'] { top: 24% !important; }
[class*='ql-top-26%'] { top: 28% !important; }
[class*='ql-top-28%'] { top: 30% !important; }
[class*='ql-top-30%'] { top: 30% !important; }
[class*='ql-top-32%'] { top: 32% !important; }
[class*='ql-top-34%'] { top: 34% !important; }
[class*='ql-top-36%'] { top: 36% !important; }
[class*='ql-top-38%'] { top: 38% !important; }
[class*='ql-top-40%'] { top: 40% !important; }
[class*='ql-top-42%'] { top: 42% !important; }
[class*='ql-top-44%'] { top: 44% !important; }
[class*='ql-top-46%'] { top: 46% !important; }
[class*='ql-top-48%'] { top: 48% !important; }
[class*='ql-top-50%'] { top: 50% !important; }
[class*='ql-top-52%'] { top: 52% !important; }
[class*='ql-top-54%'] { top: 54% !important; }
[class*='ql-top-56%'] { top: 56% !important; }
[class*='ql-top-58%'] { top: 58% !important; }
[class*='ql-top-60%'] { top: 60% !important; }
[class*='ql-top-62%'] { top: 62% !important; }
[class*='ql-top-64%'] { top: 64% !important; }
[class*='ql-top-66%'] { top: 66% !important; }
[class*='ql-top-68%'] { top: 68% !important; }
[class*='ql-top-70%'] { top: 70% !important; }
[class*='ql-top-72%'] { top: 72% !important; }
[class*='ql-top-74%'] { top: 74% !important; }
[class*='ql-top-76%'] { top: 76% !important; }
[class*='ql-top-78%'] { top: 78% !important; }
[class*='ql-top-80%'] { top: 80% !important; }
[class*='ql-top-82%'] { top: 82% !important; }
[class*='ql-top-84%'] { top: 84% !important; }
[class*='ql-top-86%'] { top: 86% !important; }
[class*='ql-top-88%'] { top: 88% !important; }
[class*='ql-top-90%'] { top: 90% !important; }
[class*='ql-top-92%'] { top: 92% !important; }
[class*='ql-top-94%'] { top: 94% !important; }
[class*='ql-top-96%'] { top: 96% !important; }
[class*='ql-top-98%'] { top: 98% !important; }
[class*='ql-top-100%'] { top: 100% !important; }

/* bottom */
[class*='ql-bottom-unset'] {
  bottom: unset !important;
}
[class*='ql-bottom-0'] {
  bottom: 0 !important;
}
[class*='ql-bottom-50%'] {
  bottom: 50% !important;
}
[class*='ql-bottom-100%'] {
  bottom: 100% !important;
}

/* right */
[class*='ql-right-unset'] {
  right: unset !important;
}
[class*='ql-right-0'] {
  right: 0 !important;
}
[class*='ql-right-50%'] {
  right: 50% !important;
}
[class*='ql-right-100%'] {
  right: 100% !important;
}

/* left */
[class*='ql-left-unset'] { left: unset !important; }
[class*='ql-left-0%'] { left: 0% !important; }
[class*='ql-left-2%'] { left: 2% !important; }
[class*='ql-left-4%'] { left: 4% !important; }
[class*='ql-left-6%'] { left: 6% !important; }
[class*='ql-left-8%'] { left: 8% !important; }
[class*='ql-left-10%'] { left: 10% !important; }
[class*='ql-left-12%'] { left: 12% !important; }
[class*='ql-left-14%'] { left: 14% !important; }
[class*='ql-left-16%'] { left: 16% !important; }
[class*='ql-left-18%'] { left: 18% !important; }
[class*='ql-left-20%'] { left: 20% !important; }
[class*='ql-left-22%'] { left: 22% !important; }
[class*='ql-left-24%'] { left: 24% !important; }
[class*='ql-left-26%'] { left: 28% !important; }
[class*='ql-left-28%'] { left: 30% !important; }
[class*='ql-left-30%'] { left: 30% !important; }
[class*='ql-left-32%'] { left: 32% !important; }
[class*='ql-left-34%'] { left: 34% !important; }
[class*='ql-left-36%'] { left: 36% !important; }
[class*='ql-left-38%'] { left: 38% !important; }
[class*='ql-left-40%'] { left: 40% !important; }
[class*='ql-left-42%'] { left: 42% !important; }
[class*='ql-left-44%'] { left: 44% !important; }
[class*='ql-left-46%'] { left: 46% !important; }
[class*='ql-left-48%'] { left: 48% !important; }
[class*='ql-left-50%'] { left: 50% !important; }
[class*='ql-left-52%'] { left: 52% !important; }
[class*='ql-left-54%'] { left: 54% !important; }
[class*='ql-left-56%'] { left: 56% !important; }
[class*='ql-left-58%'] { left: 58% !important; }
[class*='ql-left-60%'] { left: 60% !important; }
[class*='ql-left-62%'] { left: 62% !important; }
[class*='ql-left-64%'] { left: 64% !important; }
[class*='ql-left-66%'] { left: 66% !important; }
[class*='ql-left-68%'] { left: 68% !important; }
[class*='ql-left-70%'] { left: 70% !important; }
[class*='ql-left-72%'] { left: 72% !important; }
[class*='ql-left-74%'] { left: 74% !important; }
[class*='ql-left-76%'] { left: 76% !important; }
[class*='ql-left-78%'] { left: 78% !important; }
[class*='ql-left-80%'] { left: 80% !important; }
[class*='ql-left-82%'] { left: 82% !important; }
[class*='ql-left-84%'] { left: 84% !important; }
[class*='ql-left-86%'] { left: 86% !important; }
[class*='ql-left-88%'] { left: 88% !important; }
[class*='ql-left-90%'] { left: 90% !important; }
[class*='ql-left-92%'] { left: 92% !important; }
[class*='ql-left-94%'] { left: 94% !important; }
[class*='ql-left-96%'] { left: 96% !important; }
[class*='ql-left-98%'] { left: 98% !important; }
[class*='ql-left-100%'] { left: 100% !important; }

/* position */
[class*='ql-position-absolute'] {
  position: absolute !important;
}
[class*='ql-position-unset'] {
  position: unset !important;
}

/* textalign */
[class*='ql-textalign-left'] {
  text-align: left !important;
}
[class*='ql-textalign-right'] {
  text-align: right !important;
}
[class*='ql-textalign-center'] {
  text-align: center !important;
}
[class*='ql-textalign-justify'] {
  text-align: justify !important;
}

/* transform */
/* nao colocar - (hifen) no nome da classe, quill nao aceita */
[class*='ql-transform-unset'] {
  -ms-transform: unset !important;
  transform: unset !important;
}
[class*='ql-transform-translate(0%,0%)'] {
  -ms-transform: translate(0%, 0%) !important;
  transform: translate(0%, 0%) !important;
}
[class*='ql-transform-translate(0%,50%)'] {
  -ms-transform: translate(0%, -50%) !important;
  transform: translate(0%, -50%) !important;
}
[class*='ql-transform-translate(0%,100%)'] {
  -ms-transform: translate(0%, -100%) !important;
  transform: translate(0%, -100%) !important;
}
[class*='ql-transform-translate(50%,0%)'] {
  -ms-transform: translate(-50%, 0%) !important;
  transform: translate(-50%, 0%) !important;
}
[class*='ql-transform-translate(50%,50%)'] {
  -ms-transform: translate(-50%, -50%) !important;
  transform: translate(-50%, -50%) !important;
}
[class*='ql-transform-translate(50%,100%)'] {
  -ms-transform: translate(-50%, -100%) !important;
  transform: translate(-50%, -100%) !important;
}
[class*='ql-transform-translate(100%,0%)'] {
  -ms-transform: translate(-100%, 0%) !important;
  transform: translate(-100%, 0%) !important;
}
[class*='ql-transform-translate(100%,50%)'] {
  -ms-transform: translate(-100%, -50%) !important;
  transform: translate(-100%, -50%) !important;
}
[class*='ql-transform-translate(100%,100%)'] {
  -ms-transform: translate(-100%, -100%) !important;
  transform: translate(-100%, -100%) !important;
}

.titulo-mobile {
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: calc(100vw - 100px);
    overflow: hidden;
}

</style>

